































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { FavoriteViewModel, FavoriteService } from '../../api/favorite';
import FileService, { FileViewModel} from '../../api/file';
import FilePreview from '../File/Preview.vue';
import global from '../../utils/global';
@Component({
  components: {
    FilePreview,
  },
})
export default class FavoriteIndex extends Vue {
  private service: FavoriteService = new FavoriteService();
  private data: any[] = [];
  private condition: FavoriteViewModel = this.service.NewModel;
  private pageIndex: number = 1;
  private imgUrl: string = `${global.BACKGROUND_URL}/resource/thumb/` ;
  private iconClasses: any[] = ['', 'map', 'charts', 'article'];
  private routeNames: string[] = ['', 'MapDetail', 'ChartsDetail', 'LiteratureDetail'];
  private showPreview: boolean = false;
  private fileService: FileService = new FileService();
  private fileData: FileViewModel = this.fileService.NewModel;
  private created() {
    this.condition.sourceType = '-1';
  }
  private mounted() {
    this.search(this.condition, 1);
  }
  private search(condition: FavoriteViewModel, pageIndex: number) {
    this.service.Search(condition, pageIndex).then((response: any) => {
      this.pageIndex = pageIndex;
      this.data = response;
    });
  }
  private page_OnChange(page: number) {
    this.search(this.condition, page);
  }
  private tab_OnClick(tab: any, event: any) {
    this.condition.sourceType = tab.name;
    this.search(this.condition, 1);
  }
  private btnPreview_OnClick(item: FavoriteViewModel) {
    if (item.sourceType === 0) {
      this.fileService.Get(item.sourceID!).then((repsonse: any) => {
        this.fileData = repsonse;
        this.showPreview = true;
      });
    } else {
      const type: string = item.sourceType!.toString();
      this.$router.push({name: this.routeNames[parseInt(type)], query: {id: item.sourceID}});
    }
  }
}
